import { createApp } from 'vue'
import Antd from 'ant-design-vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import 'ant-design-vue/dist/antd.css'
import 'polyfill-object.fromentries'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'


const app = createApp(App).component('font-awesome-icon', FontAwesomeIcon).use(Antd).use(router).use(store)
;

// 注册全局组件
// Object.keys(faAddressBook).forEach(key => {
//     app.component(key, faAddressBook[key]);
// });

app.mount('#app');